import { ArrowDownRight, ArrowUpRight } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface Props {
  difference: number;
  uomName?: string;
  className?: string;
}

export function StockAdjustmentDiffBadge({
  difference,
  uomName,
  className,
}: Props) {
  const suffix = uomName ? ` ${uomName}` : "";

  if (difference === 0) {
    return (
      <Badge variant="outline" className={cn("text-[10px]", className)}>
        0{suffix}
      </Badge>
    );
  }

  if (difference > 0) {
    return (
      <Badge
        variant="secondary"
        className={cn(
          "border-emerald-500/20 bg-emerald-500/10 text-[10px] font-semibold text-emerald-700 dark:text-emerald-300",
          className,
        )}
      >
        <ArrowUpRight className="mr-0.5 h-2.5 w-2.5" />+{difference}
        {suffix}
      </Badge>
    );
  }

  return (
    <Badge
      variant="destructive"
      className={cn("text-[10px] font-semibold", className)}
    >
      <ArrowDownRight className="mr-0.5 h-2.5 w-2.5" />
      {difference}
      {suffix}
    </Badge>
  );
}
